import * as React from 'react';
import {HomePageContent} from "../HomePageContent/HomePageContent";
import BomListingHeader from "./BomListing/BomListingHeader/BomListingHeader";
import {BomProductNotification} from "./BomProductNotification";

export function BomProductListing() {
    return (
        <>
            <BomListingHeader/>
            <BomProductNotification/>
            <HomePageContent
                isBomPLP="yes"
                addToBOMSwapModeByBomDetailID="yes"
            />
        </>
    );

}
